import { render, staticRenderFns } from "./Unique.vue?vue&type=template&id=445b80f4&scoped=true"
import script from "./Unique.vue?vue&type=script&lang=js"
export * from "./Unique.vue?vue&type=script&lang=js"
import style0 from "./Unique.vue?vue&type=style&index=0&id=445b80f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "445b80f4",
  null
  
)

export default component.exports